module.exports = __webpack_public_path__ + "img/Icon_Unreported_Discipline_Hover.da54c5ca.svg";